import React from 'react';
import styled from 'styled-components';
import { Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { Dropdown } from '../../../shared/ui/Dropdown';
import { downloadFile } from '../../../utils/common/downloadFile';

type Props = {
    type: Type;
};

export enum Type {
    users = 'users',
    payments = 'payments',
    communities = 'communities',
    feedback = 'feedback',
}

const formats = [
    { label: 'XLSX', type: 'xlsx' },
    { label: 'CSV', type: 'csv' },
];

export const Download = ({ type }: Props) => {
    const handleDownload = (format: string) => {
        void downloadFile(`/manager/export/${type}`, format, { type: format });
    };

    return (
        <StyledActions>
            <StyledDropdown
                dropdownContent={() =>
                    formats.map(({ label, type: formatType }) => (
                        <Button
                            key={formatType}
                            type='text'
                            onClick={() => handleDownload(formatType)}
                        >
                            {label}
                        </Button>
                    ))
                }
            >
                <Button type='default'>
                    Скачать <DownOutlined />
                </Button>
            </StyledDropdown>
        </StyledActions>
    );
};

const StyledActions = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
`;

const StyledDropdown = styled(Dropdown)`
    cursor: pointer;
`;
